import { LearnerObjectiveAccessCompactModel } from '@/api/models/aggregate'
import { Course } from '@/components/courses/Course/Course'
import { CoursesListItemsWrapper } from '@/components/courses/CoursesListItemsWrapper/CoursesListItemsWrapper'

type Props = {
  enrolledCourses: LearnerObjectiveAccessCompactModel[]
  totalEnrolledCourses: number
}

export const CoursesListRender = ({ enrolledCourses }: Props) => {
  return (
    <CoursesListItemsWrapper>
      {enrolledCourses.map((aggregate) => (
        <Course key={aggregate.id} aggregate={aggregate} />
      ))}
    </CoursesListItemsWrapper>
  )
}
